/* eslint-disable */
// @ts-nocheck

/**
 * This code is copy pasted from a qualtrics intercept project. Run this code to enable
 * qualtrics to evaluate the intercept that is setup. If the conditions set on the
 * intercept pass, the qualtrics logged out survey will be shown to the user.
 */
export function loadQualtricsLoggedOutSurvey() {
  (function () {
    var g = function (g) {
      this.go = function () {
        var a = document.createElement("script");
        a.type = "text/javascript";
        a.src = g;
        document.body && document.body.appendChild(a);
      };

      this.start = function () {
        var t = this;
        "complete" !== document.readyState
          ? window.addEventListener
            ? window.addEventListener(
                "load",
                function () {
                  t.go();
                },
                !1
              )
            : window.attachEvent &&
              window.attachEvent("onload", function () {
                t.go();
              })
          : t.go();
      };
    };

    try {
      new g(
        "https://znbygwcvew7hwvj38-faire.siteintercept.qualtrics.com/SIE/?Q_ZID=ZN_byGWcVew7hWvj38"
      ).start();
    } catch (i) {}
  })();
}
